import { LoyaltyStatusQuery } from '@generated'

export function getMembershipName(data: LoyaltyStatusQuery | null): string {
  if (data && data.loyaltyStatus && data.loyaltyStatus.loyalty_nr) {
    switch (data.loyaltyStatus.loyalty_nr) {
      case 4:
        return 'GASSAN Member'
      case 3:
        return 'Gold Member'
      case 2:
        return 'Platinum Member'
      case 1:
        return 'Diamond Member'
    }
  }

  return 'Account Member'
}
